'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logQPromiseIssuesAndSendNonApiAlerts = exports.logQPromiseIssuesAndSendAlerts = exports.logQPromiseIssuesToConsole = undefined;

var _handleDoneErrors = require('./handleDoneErrors');

var _handleUnhandledErrors = require('./handleUnhandledErrors');

var _longStackTracesForDev = require('./longStackTracesForDev');

(0, _longStackTracesForDev.enableLongStackTracesForDev)();

var willCallBoth = function willCallBoth(func1, func2) {
  return function () {
    func1();
    func2();
  };
};

var logQPromiseIssuesToConsole = exports.logQPromiseIssuesToConsole = willCallBoth(_handleDoneErrors.logDoneRejectionsToConsole, _handleUnhandledErrors.logUnhandledErrorsToConsole);

var logQPromiseIssuesAndSendAlerts = exports.logQPromiseIssuesAndSendAlerts = willCallBoth(_handleDoneErrors.logDoneRejectionsAndSendAlerts, _handleUnhandledErrors.logUnhandledErrorsAndSendAlerts);

var logQPromiseIssuesAndSendNonApiAlerts = exports.logQPromiseIssuesAndSendNonApiAlerts = willCallBoth(_handleDoneErrors.logDoneRejectionsAndSendNonApiAlerts, _handleUnhandledErrors.logUnhandledErrorsAndSendNonApiAlerts);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/q/static-3.28/js/handlers.js
// module id = 448
// module chunks = 0